import React from "react";

import cn from "classnames";

import styles from "./LoadingDots.module.scss";

interface Props {
  mini?: boolean;
}

const LoadingDots: React.FC<Props> = ({ mini }) => {
  return <div className={cn(styles.loader, { [styles.miniLoader]: !!mini })} />;
};

export default LoadingDots;
